import Modal from "antd/lib/modal/Modal";
import { Button } from "antd";
import moment from "moment";
import dayjsTZ from "../../../../utils/dayjs";
import { useCallback, useEffect, useState } from "react";
import "./PagatLogs.scss";
import { htmlParser } from "../../../../utils";
import { ModalXIcon } from "../../../../assets/icons";
import AgGridComponent from "../../../AG-grid/AgGridComponent";
import MondayButton from "../../../commonComponents/MondayButton/MondayButton";

const PagatLogs = ({ data, isVisible, setIsVisible, logsName }) => {
  const [tableData, setTableData] = useState([]);
  const authorFormatter = (params) => {
    if (params.value) {
      const author = `${params.value.employeeFirstName} ${params.value.employeeLastname}`;
      return author;
    }
    return "";
  };

  const dateFormatter = (params) => {
    if (params.value) {
      const formattedDate = dayjsTZ(params.value).format("DD/MM/YYYY HH:mm ");
      return formattedDate;
    }
    return "";
  };

  const columnDefs = [
    {
      headerName: "Autori",
      field: "author",
      valueFormatter: authorFormatter,
    },
    {
      headerName: "Titulli",
      field: "title",
    },
    {
      headerName: "Koha e ndryshimit",
      field: "changeDate",
      valueFormatter: dateFormatter,
    },
    {
      headerName: "Fusha  e ndryshuar",
      field: "field",
    },
    {
      headerName: "Activity",
      field: "activity",
      cellRenderer: (params) => {
        return htmlParser(params.value);
      },
    },
    {
      headerName: "Si Ishte",
      field: "previousData",
      cellRenderer: (params) => {
        return htmlParser(params.value);
      },
    },
    {
      headerName: "Si u Be",
      field: "currentData",
      cellRenderer: (params) => {
        return htmlParser(params.value);
      },
    },
  ];

  const onFirstDataRendered = useCallback((param) => {
    param.api.autoSizeAllColumns(false);
  }, []);

  useEffect(() => {
    let values = [];
    if (logsName === "Fitimet") {
      if (data?.length !== 0) {
        data?.forEach((item) => {
          if (item?.earningLogs && item?.earningLogs.length !== 0) {
            item?.earningLogs?.forEach((e) => {
              e.forEach((i) => {
                values.push({ ...i, title: item?.earningName });
              });
            });
          }
        });
      }
    } else if (logsName === "Zbritjet") {
      console.log(data);
      if (data?.length !== 0) {
        data?.forEach((item) => {
          if (item?.deductionLogs && item?.deductionLogs.length !== 0) {
            item?.deductionLogs?.forEach((e) => {
              e.forEach((i) => {
                values.push({ ...i, title: item?.deductionName });
              });
            });
          }
        });
      }
    }
    setTableData(values);
  }, [isVisible]);

  return (
    <Modal
      className="pagatLogs lightHeader"
      open={isVisible}
      onCancel={() => setIsVisible(false)}
      destroyOnHidden
      title={`${logsName} Logs`}
      closeIcon={<ModalXIcon />}
      width={1000}
      footer={[
        <MondayButton
          className="mondayButtonRed"
          onClick={() => setIsVisible(false)}
        >
          Mbyllni faqen
        </MondayButton>,
      ]}
    >
      <div
        className="ag-theme-alpine"
        style={{ width: "100%", height: "100%", borderRadius: "5px" }}
      >
        <AgGridComponent
          columnDefs={columnDefs}
          customDefaultColDef={{ flex: undefined }}
          rowData={tableData}
          overlayLoadingTemplate="Historiku është bosh!"
          autoSizeStrategy={{ type: "fitCellContents" }}
          onFirstDataRendered={onFirstDataRendered}
        />
      </div>
    </Modal>
  );
};

export default PagatLogs;
